import { Route } from 'react-router-dom';
import { ExperienceSessionList } from './list';
import { ExperienceSessionShow } from './show';

export const ExperienceSessionsRoute = (
  <Route path="sessions">
    <Route index element={<ExperienceSessionList />} />
    <Route path=":id" element={<ExperienceSessionShow />} />
  </Route>
);
